/* eslint-disable no-shadow */
export enum AcceptanceMethodEnum {
	checkBox = 'checkBox',
	seller = 'seller',
}

export enum LanguageEnum {
	es = 'es',
}
